// @ts-nocheck
import { ReactComponent as Icon } from '../../assets/icons/phoneIcon.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" alt="Plug" aria-label="Plug" />;
}
